module.exports = __webpack_public_path__ + "c0036735783dd80289faeb3be5e656b5.png";